module.exports = __webpack_public_path__ + "img/image1.1d4031ce.jpg";